import * as _ from "underscore";
import { App } from "./app";

const rootUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;
const RequestVerificationToken: string = <string>$("input[name='__RequestVerificationToken']").val();

export class Api {

    public static GetUrl(path: string) {
        return rootUrl + (rootUrl.endsWith("/") ? "" : "/") + path;
    }

    private static fail(result: JQuery.jqXHR<any>) {
        console.log("Error: " + result.status + ", " + result.statusText)
    }

    private static getJson(url) {

        App.busy(true);

        return $.getJSON(url)
            .always(() => App.busy(false))
            .fail(result => this.fail(result));
    }

    private static postForm(data, url) {

        //<form> to (non api) Controller
        return $.ajax({
            type: 'POST',
            url: url,
            cache: false,
            headers: { "RequestVerificationToken": RequestVerificationToken },
            data: data
        }).fail(result => this.fail(result));
    }

    private static postJson(data, url) {

        return $.ajax({
            type: 'POST',
            url: url,
            cache: false,
            headers: { "RequestVerificationToken": RequestVerificationToken },
            contentType: "application/json",
            dataType: 'json',
            data: JSON.stringify(data),
        })
            .fail(result => this.fail(result));
    }

    public static Cancel(data): JQueryXHR {
        return this.postJson(data, "/api/register/cancel");
    }

    public static CancelForCredit(data): JQueryXHR {
        return this.postJson(data, "/api/account/cancel-registration");
    }

    public static ChangePassword(data): JQueryXHR {
        return this.postJson(data, "/api/user/change-password");
    }

    public static Checkout(data): JQueryXHR {
        return this.postJson(data, "/api/register/checkout");
    }

    public static ChineseSupport(data): JQueryXHR {
        return this.postJson(data, "/api/support/chinese-support");
    }

    public static ContactUs(data): JQueryXHR {
        return this.postJson(data, "/api/support/contact-us");
    }

    public static ForgotPassword(data): JQueryXHR {
        return this.postJson(data, "/api/user/forgot-password");
    }

    public static GetActivityInfo(id: number): JQueryXHR {
        return $.get("info/activity/" + id);
    }

    public static GetAlert(data): JQueryXHR {
        return this.postForm(data, "alert");
    }

    public static GetAlert2(data): JQueryXHR {
        return this.postForm(data, "alert2");
    }

    public static GetAvailabilityInfo(): JQueryXHR {
        return $.get("info/availability");
    }

    public static GetCancellationPolicyInfo(): JQueryXHR {
        return $.get("info/cancellation-policy");
    }

    public static GetDonationInfo(): JQueryXHR {
        return $.get("info/donation");
    }

    public static GetLocationInfo(data): JQueryXHR {
        return this.postJson(data, "/api/register/info/location");
    }

    public static GetLocations(data): JQueryXHR {
        return this.postJson(data, "/api/register/locations");
    }

    public static GetOrderDetails(data): JQueryXHR {
        return this.postJson(data, "/api/order/details");
    }

    public static GetPrivacyPolicyInfo(): JQueryXHR {
        return $.get("info/privacy-policy");
    }

    public static GetSkillLevelInfo(id): JQueryXHR {
        return this.getJson("/api/content/skill-level-info/" + id);
    }

    public static RemoveCreditCard(data): JQueryXHR {
        return this.postJson(data, "/api/account/remove-credit-card");
    }

    public static GetSkillLevels(data): JQueryXHR {
        return this.postJson(data, "/api/register/skill-levels");
    }

    public static GetTimer(): JQueryXHR {
        return $.get("register/timer");
    }

    public static GetVolunteerLinksInfo(): JQueryXHR {
        return $.get("info/volunteer-links");
    }

    public static GetWaiverInfo(): JQueryXHR {
        return $.get("info/waiver");
    }

    public static Options(data): JQueryXHR {
        return this.postJson(data, "/api/register/options");
    }

    public static PromoCode(data): JQueryXHR {
        return this.postJson(data, "/api/register/promo-code");
    }

    public static Register(data): JQueryXHR {
        return this.postJson(data, "/api/register/save");
    }

    public static ResendOrderConfirmation(data): JQueryXHR {
        return this.postJson(data, "/api/account/resend-order-confirmation");
    }

    public static Review(): JQueryXHR {
        return this.postJson({}, "/api/register/review");
    }

    public static SaveAccount(data): JQueryXHR {
        return this.postJson(data, "/api/account/save");
    }

    public static SaveChild(data): JQueryXHR {
        return this.postJson(data, "/api/account/child/save");
    }

    public static SignIn(data): JQueryXHR {
        return this.postForm(data, "/user/sign-in");
    }

    public static SearchCamps(data): JQueryXHR {
        return this.postJson(data, "/api/register/allocations");
    }

    public static SetPassword(data): JQueryXHR {
        return this.postJson(data, "/api/user/set-password");
    }

    public static UniqueChildName(data): JQueryXHR {
        return this.postJson(data, "/api/account/child/unique-name");
    }

    public static UniqueEmail(data): JQueryXHR {
        return this.postJson(data, "/api/account/unique-email");
    }

    public static UpdateAccountSkillLevel(data): JQueryXHR {
        return this.postJson(data, "/api/account/update-skill-level");
    }

    public static WaitList(data): JQueryXHR {
        return this.postJson(data, "/api/support/wait-list");
    }

    public static NoResults(msg, results): boolean {
        if (!_(results).any()) {
            console.log(msg);
            window.alert(msg);
            return true;
        }

        return false;
    }
}
